import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import translate from '../../lib/i18n/translate'
import numeral from 'numeral';
import {LoomisColors} from '../../lib/LoomisColors';

import './TransactionDayList.css'

const TransactionDayList = ({days, openTransactionDay, openTransactionDayPick, strings}) => {

    const {Date, Sales, Pickup, Balance} = strings;

    const rowPadding = {padding: "5px"};

    const displayAmount = (amount, currency) => {
        return (
            <div>
                <div>{numeral(amount/100).format('0,0.00')}  <span style={{color:LoomisColors.darkGrey,fontSize: 10}}>{currency}</span></div>
            </div>
        )
    }

    const summary = (amount, currency) => {
        return (
            <div>
                 {amount === 0 ? "-" : displayAmount(amount, currency)}
            </div>
        )
    }


    const displayCollectNoConfirm = (amount, currency) => {
        return (
            <div>
                <div className="AmountPickup">{numeral(amount*-1/100).format('0,0.00')}  <span style={{color:LoomisColors.darkGrey,fontSize: 10}}>{currency}</span></div>
            </div>
        )
    }

    const displayCollectOkConfirm = (amount, currency) => {
        return (
            <div>
                <div className="AmountOK">{numeral(amount*-1/100).format('0,0.00')}  <span style={{color:LoomisColors.darkGrey,fontSize: 10}}>{currency}</span></div>
            </div>
        )
    }

    const displayCollectNokConfirm = (amount, diff, currency) => {
        return (
            <div>
                <div className="AmountNOK">{numeral(amount*-1/100).format('0,0.00')} ({numeral(diff*-1/100).format('0,0.00')})  <span style={{color:LoomisColors.darkGrey,fontSize: 10}}>{currency}</span></div>
            </div>
        )
    }

    const collection = (collectAmount, confirmedAmount, diffAmount, currency) => {
        return (
            <div>
                 {collectAmount === 0 ? "-" : (confirmedAmount === 0 && diffAmount === 0) ? displayCollectNoConfirm(collectAmount, currency) : diffAmount === 0 ? displayCollectOkConfirm(collectAmount, currency) : displayCollectNokConfirm(collectAmount, diffAmount, currency)}
            </div>
        )
    }

    return (
        <div className="TransactionDayList">
            <Table onCellClick={(rowNumber) => openTransactionDay(rowNumber)}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                    <TableRow>
                        <TableHeaderColumn style={{width:'80px'}} className="centerText">{Date}</TableHeaderColumn>
                        <TableHeaderColumn className="rightText">{Sales}</TableHeaderColumn>
                        <TableHeaderColumn className="rightText">{Pickup}</TableHeaderColumn>
                        <TableHeaderColumn className="rightText">{Balance}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} showRowHover={true}>
                    {
                        days.map((day, i) => (
                            <TableRow key={i} style={rowPadding}>
                                <TableRowColumn style={{width:'80px'}} className="centerText">{day.day}</TableRowColumn>
                                <TableRowColumn style={rowPadding} className="rightText">
                                    {
                                    day.details.map((det, j) => (
                                        <div key={j}>
                                           {summary(det.salesProcessedAmount + det.salesUnprocessedAmount, det.currency)}
                                        </div>
                                        ))
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={rowPadding} className="rightText">
                                    {
                                    day.details.map((det, j) => (
                                        <div key={j}>
                                           {collection(det.collectionAmount, det.confirmedAmount, det.diffAmount, det.currency)}
                                       </div>
                                    ))
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={rowPadding} className="rightText">
                                    {
                                    day.details.map((det, j) => (
                                        <div key={j}>
                                            {summary(det.balanceSafebagAmount + det.balanceRecyclableAmount + det.balanceOverflowAmount + det.balanceManualDepositAmount, det.currency)}
                                        </div>
                                    ))
                                    }
                                </TableRowColumn>
                            </TableRow>
                        ))
                    }
                    </TableBody>
            </Table>
        </div>
    )
};

export default translate('TransactionDayList')(TransactionDayList);


// WEBPACK FOOTER //
// ./src/components/transactionDayList/TransactionDayList.js